exports.components = {
  "component---src-pages-about-jsx": () => import("./../../../src/pages/about.jsx" /* webpackChunkName: "component---src-pages-about-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-photographer-jsx": () => import("./../../../src/pages/photographer.jsx" /* webpackChunkName: "component---src-pages-photographer-jsx" */)
}

